'use client';

import Search, { SearchSkeleton } from '@/components/layout/navbar/search';
import { Button } from '@/components/ui/button';
import { Search as SearchIcon, X } from 'lucide-react';
import { Suspense } from 'react';

interface SearchToggleProps {
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
}

export default function SearchToggle({ searchOpen, setSearchOpen }: SearchToggleProps) {
  return (
    <>
      {/* Search Button */}
      {!searchOpen && (
        <button onClick={() => setSearchOpen(true)} className="p-2">
          <SearchIcon className="h-4 w-4" />
        </button>
      )}

      {/* Fullscreen Search Overlay */}
      {searchOpen && (
        <div className="absolute top-0 left-1/2 z-[60] flex h-16 w-full max-w-2xl -translate-x-1/2 transform items-center justify-center rounded-md">
          <div className="w-full px-4">
            <Suspense fallback={<SearchSkeleton />}>
              <Search />
            </Suspense>
          </div>
          {/* Close Button */}
          <Button
            variant="ghost"
            className="cursor-pointer"
            size="icon"
            onClick={() => setSearchOpen(false)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      )}
    </>
  );
}
